"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.999 0C3.588 0 0 3.589 0 7.999a7.94 7.94 0 0 0 2.345 5.653 7.939 7.939 0 0 0 5.653 2.345c4.41 0 7.998-3.588 7.998-7.999a7.944 7.944 0 0 0-2.344-5.653A7.945 7.945 0 0 0 7.999 0Zm0 1a7.005 7.005 0 0 1 6.997 6.998c0 3.859-3.139 6.999-6.998 6.999C4.139 14.998 1 11.858 1 7.999A7.007 7.007 0 0 1 7.999 1Zm-.708 7.02L3.894 4.625l.707-.707 3.397 3.397 3.397-3.397.707.707-3.397 3.397 3.396 3.396-.707.707-3.396-3.396-3.397 3.396-.707-.707 3.397-3.396Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.96.005C5.365.005 0 5.371 0 11.965c0 3.19 1.245 6.192 3.506 8.454a11.88 11.88 0 0 0 8.454 3.507c6.593 0 11.957-5.366 11.958-11.96a11.88 11.88 0 0 0-3.505-8.454A11.878 11.878 0 0 0 11.96.005Zm0 1.125c5.974 0 10.833 4.86 10.833 10.835 0 5.975-4.859 10.836-10.833 10.836-5.975 0-10.835-4.861-10.835-10.836 0-5.974 4.86-10.835 10.835-10.835Zm-.757 10.835-5.98-5.98.795-.796 5.98 5.98 5.982-5.98.795.796-5.98 5.98 5.98 5.98-.795.797-5.981-5.981-5.98 5.98-.797-.795 5.981-5.98Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.947.007C7.154.007 0 7.16 0 15.954c0 4.253 1.66 8.256 4.675 11.27a15.84 15.84 0 0 0 11.271 4.677c8.792 0 15.944-7.154 15.945-15.947 0-4.254-1.66-8.257-4.674-11.271A15.837 15.837 0 0 0 15.947.007Zm0 1.5c7.965 0 14.444 6.48 14.444 14.447 0 7.966-6.479 14.447-14.445 14.447S1.5 23.92 1.5 15.954c0-7.966 6.481-14.447 14.447-14.447Zm-1.01 14.447L6.965 7.98l1.06-1.061L16 14.893l7.974-7.974 1.06 1.06-7.974 7.975 7.975 7.974-1.061 1.06L16 17.014l-7.975 7.975-1.06-1.061 7.974-7.974Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24.004.028C10.796.028.049 10.774.049 23.983c0 6.389 2.494 12.402 7.024 16.931 4.529 4.53 10.542 7.024 16.93 7.024 13.208 0 23.952-10.746 23.953-23.955 0-6.39-2.495-12.402-7.022-16.931-4.529-4.53-10.54-7.024-16.93-7.024Zm0 1.875c12.175 0 22.077 9.905 22.077 22.08 0 12.175-9.903 22.08-22.077 22.08-12.175 0-22.08-9.905-22.08-22.08 0-12.175 9.906-22.08 22.08-22.08Zm-1.33 22.08-12.52-12.519 1.327-1.326L24 22.658l12.52-12.52 1.325 1.326-12.519 12.519 12.52 12.52-1.326 1.325L24 25.31 11.48 37.83l-1.325-1.327 12.519-12.519Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32.005.038C14.395.038.065 14.366.065 31.978c0 8.518 3.326 16.536 9.365 22.575 6.04 6.039 14.056 9.365 22.575 9.365 17.61 0 31.935-14.328 31.936-31.94 0-8.52-3.326-16.536-9.363-22.575C48.54 3.363 40.524.038 32.005.038Zm0 2.5c16.233 0 29.436 13.207 29.436 29.44s-13.204 29.44-29.436 29.44c-16.233 0-29.44-13.207-29.44-29.44s13.208-29.44 29.44-29.44Zm-1.773 29.44L13.54 15.285l1.768-1.768L32 30.209l16.692-16.692 1.768 1.769-16.692 16.691L50.461 48.67l-1.768 1.769L32 33.745 15.307 50.438l-1.768-1.769 16.693-16.692Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCloseCircle = function IconCloseCircle(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Close Circle' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "CloseCircle"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCloseCircle.sizes = [16, 24, 32, 48, 64];
IconCloseCircle.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCloseCircle;
exports.default = _default;